<template>
<div class="changePasswordScreen">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("forms.changePassword.title")}}</h3>
						</div>
						<div class="col-4 text-right">
							<router-link class="btn btn-sm btn-danger" to="/profile">{{$t('actions.cancel')}}</router-link>
						</div>
					</div>
					<hr>
				</div>
				<div class="card-body">
					<form @submit.prevent="changePasswordFormSubmit">
						<div class="form-group row">
							<label for="currentPassword" class="col-md-4 col-form-label text-md-right">{{$t("forms.changePassword.currentPasswordLabel")}}</label>
							<div class="col-md-6">
								<input type="password" v-model="currentPassword" name="currentPassword" class="form-control"
								autofocus :class="{ 'is-invalid': submitted && !currentPassword }" />
								<div v-show="submitted && !currentPassword" class="invalid-feedback">{{$t("forms.changePassword.currentPasswordRequiredValidation")}}</div>
							</div>
						</div>

						<div class="form-group row">
							<label for="password" class="col-md-4 col-form-label text-md-right">{{$t("forms.changePassword.newPasswordLabel")}}</label>
							<div class="col-md-6">
								<input type="password" v-model="password" autocomplete="new-password" name="password" class="form-control"
									:class="{ 'is-invalid': submitted && !password }" />
								<div v-show="submitted && !password" class="invalid-feedback">{{$t("forms.changePassword.newPasswordRequiredValidation")}}</div>
							</div>
						</div>

						<div class="form-group row">
							<label for="confirmPassword" class="col-md-4 col-form-label text-md-right">{{$t("forms.changePassword.confirmPasswordLabel")}}</label>
							<div class="col-md-6">
								<input type="password" v-model="confirmPassword" autocomplete="new-password" name="confirmPassword" class="form-control"
									:class="{ 'is-invalid': submitted && (!confirmPassword || (confirmPassword && password != confirmPassword))}" />
								<div v-show="submitted && !confirmPassword" class="invalid-feedback">{{$t("forms.changePassword.confirmPasswordRequiredValidation")}}</div>
								<div v-show="submitted && confirmPassword && password !== confirmPassword" class="invalid-feedback">{{$t("forms.changePassword.confirmPasswordMatchValidation")}}</div>
							</div>
						</div>

						<div class="form-group">
							<ul class="errors-list">
								<li class="d-inline-block" :key="item" v-for="item in errors">
									{{ item }}
								</li>
							</ul>
						</div>

						<div class="col-md-6 offset-md-4">
							<button type="submit" :disabled="status.loading" class="btn btn-primary">
								<img v-show="status.loading" 
									src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
								{{$t("actions.changePassword")}}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
</div>
</template>
<script>
import { mapActions } from "vuex";
import WebApi from './../services/apiService.js';

export default {
	data() {
		return {
			currentPassword: "",
			password: "",
			confirmPassword: "",
			submitted: false,
			status: {
				loading: false
			},
			errors: []
		};
	},
	methods: {
		...mapActions("account", ["getUserProfile", "logout"]),
		changePasswordFormSubmit(/*e*/) {
			//console.log(e);
			this.submitted = true;
			if( !this.password || !this.confirmPassword || this.password != this.confirmPassword) return;
			//console.log('test trest')

			this.status.loading = true;
			const changePassModel = {
				userGuid: this.$store.state.account.guid,
				CurrentPassword: this.currentPassword,
				newPassword: this.password,
				confirmNewPassword: this.confirmPassword
			};
			WebApi.changePassword(changePassModel)
			.then((response) => {
				console.log('r:' , response)
				if(!response.data.success){
					this.errors.length = 0;
					response.data.errors.forEach(function(v) { this.errors.push(v); }, this);
					this.status.loading = false;
				}else{
					this.status.loading = false;
					this.$router.replace("/profile");
				}
			})
			.catch(err => {
				console.log(err);     
				this.status.loading = false;
				this.errors = ['Something went wrong. Password was not changed. Please retry.'];
			});			
		}
    }
};
</script>

<style>
	.errors-list { color: #dc3545; }
</style>